import { Button } from "../primitives/Button";
import { Icon } from "../icons/Icon";
import type { SpotCheck } from "../types";

/** Fast good-or-wrong pass over a reply the AI sent on its own. Keyboard: G and W. */
export function SpotCheckBar({ verdict, onGood, onWrong, onReset, remaining }: { verdict: SpotCheck | null | undefined; onGood: () => void; onWrong: () => void; onReset: () => void; remaining: number }) {
  if (verdict) {
    return (
      <div className="ob-spotcheck">
        <span className="ob-spotcheck__verdict"><Icon name={verdict === "good" ? "checkCircle" : "x"} size="sm" />{verdict === "good" ? "Checked: the AI answered this correctly." : "Checked: marked wrong and reopened for a human reply."}</span>
        <Button variant="ghost" size="sm" onClick={onReset}>Undo</Button>
        <span className="ob-spotcheck__hint">{remaining} left to check</span>
      </div>
    );
  }
  return (
    <div className="ob-spotcheck">
      <span className="ob-spotcheck__q">Was this reply right?</span>
      <Button variant="primary" icon="check" onClick={onGood}>Good <span className="ob-kbd">G</span></Button>
      <Button icon="x" onClick={onWrong}>Wrong, reopen <span className="ob-kbd">W</span></Button>
      <span className="ob-spotcheck__hint">{remaining} left to check · you move to the next one automatically</span>
    </div>
  );
}
